// import InputMenu from "../../../../Component/Super-admin/Component/InputMenu";
// import InsideTextBox from "../../../../Component/Super-admin/Component/InsideTextBox";
// import MultitextBox from "../../../../Component/Super-admin/Component/MultitextBox";
// import { useGetHospitalTypesQuery } from "../../../../Service/hospitalTypes";
import Checkbox from "../../Customer/Component/Checkbox";
import MultiSelect from "../../Customer/Component/MultiSelect";
import Input from "../Component/Input";

export const ContactInfo = [
  {
    tag: Input,
    img: "phone",
    label: "Phone 1",
    name: "contact_1",
    validation: "phone",
    required: true,
  },
  {
    tag: Input,
    img: "phone",
    label: "Phone 2",
    name: "contact_2",
    validation: "phone",
  },
  {
    tag: Input,
    img: "email",
    label: "Email 1",
    name: "email1",
    validation: "email",
    required: true,
  },
  {
    tag: Input,
    img: "email",
    label: "Email 2",
    name: "email2",
    validation: "email",
  },
  { tag: Input, img: "city", label: "Website", name: "website" },
  {
    tag: Input,
    img: "city",
    label: "City",
    name: "city",
    validation: "required",
  },
  {
    tag: Input,
    img: "area",
    label: "Address",
    name: "address",
    validation: "required",
  },
];

export const LoginInfo = [
  // { tag: Input, img: "name", label: "Username", name: "username",validation:"required" },
  {
    tag: Input,
    img: "email",
    label: "Email",
    name: "email",
    validation: "email",
    required: true,
  },
  {
    tag: Input,
    img: "password",
    label: "Password",
    name: "password",
    validation: "password",
  },
];
export const SpotlightInfo = [
  {
    tag: Input,
    img: "city",
    label: "Spotlight",
    name: "spotlight_id",
    validation: "required",
  },
];
export const MedicineInfo = [
  {
    tag: Input,
    img: "",
    label: "Medicine Name",
    name: "medicineName",
    validation: "required",
    required: true,
    key: "medicineName",
  },
  {
    tag: Input,
    img: "",
    label: "Type",
    name: "medicineType",
    validation: "required",
    key: "medicineType",
  },
  {
    tag: Input,
    img: "",
    label: "Dose",
    name: "medicineDose",
    validation: "required",
    key: "medicineDose",
  },
  {
    tag: Input,
    img: "",
    label: "Manufacture",
    name: "manufacturing",
    validation: "required",
    key: "manufacturing",
  },
  {
    tag: Input,
    img: "",
    label: "Count",
    name: "count",
    validation: "required",
    key: "count", 
  },
];
export const Extras = [
  { tag: Input, img: "name", label: "Occupation", name: "occupation" },
  {
    tag: Input,
    img: "name",
    label: "Spouse Occupation",
    name: "spouse_occupation",
  },
  { tag: Input, img: "", label: "Area of Interest", name: "area_of_interest" },
];
